import cpt from './component.vue'
import Vue from 'vue'
export default {
    install: () => {
        const toastConstruct = Vue.extend(cpt)
        Vue.prototype.$toast = (message) => {
            let toastCol = new toastConstruct({
                data() {
                    return {
                        message
                    }
                }
            })
            toastCol.$mount();
            document.body.appendChild(toastCol.$el)
            let sto = setTimeout(() => {
                clearTimeout(sto)
                sto = null
                document.body.removeChild(toastCol.$el)
                toastCol = null
            },3000)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/toast/index.js